<template>
  <div v-if="info">
    <Me />
    <Evaluation :resultName="'evaluationResult'" />
    <ContractCurrent :resultName="'contractCurrentResult'" @emitNext="next" />
    <LoadingSuccess v-if="isLoadingSuccess" />

    <template v-if="isLoadingSuccess">
      <template v-if="isSignupManage === false">
        <LoansOngoing />
        <SignupProblem :resultName="'signupProblemResult'" @emitNext="next"></SignupProblem>
        <!-- <div> signupProblemResult {{ signupProblemResult }} </div> -->
        <Agreement v-if="signupProblemResult" :resultName="'agreementResult'" @emitNext="next" />
        <!-- <div> isBuynowWooriCrowd {{ isBuynowWooriCrowd }} </div> -->
        <template v-if="contractStatus === 'pending'">
          <!-- 본인인증 우선 -->
          <!-- <KycMobile v-if="agreementResult" :resultName="'kycMobileResult'" @emitNext="next" /> -->
          <KycMobileWooriCrowd
            v-if="agreementResult"
            :contractStatus="contractStatus"
            :resultName="'kycMobileWooriCrowdResult'"
            @emitNext="next"
          />
          <!-- 상점정보 등록 -->
          <Store 
            v-if="kycMobileWooriCrowdResult" 
            :resultName="isBuynowWooriCrowd ? 'salesAccountResult' : 'storeResult'" 
            @emitNext="next" 
          />
          <!-- 여신협회계정 -->
          <SalesAccount v-if="storeResult" :resultName="'salesAccountResult'" @emitNext="next" />
          <!-- 신용조회 -->
          <FactoringConfirm
            v-if="salesAccountResult"
            :resultName="'factoringConfirmResult'"
            @emitNext="next"
          />
          <FactoringSuccess
            v-if="factoringConfirmResult"
            :resultName="'factoringSuccessResult'"
            @emitNext="next"
          />
        </template>
        <template v-else-if="contractStatus === 'completed'">
          <!-- 본인확인 -->
          <KycMobileDefault
            v-if="agreementResult"
            :resultName="'kycMobileDefault'"
            @emitNext="next"
          />
          <!-- 1.신분증 인증 2. 사업자 등록증 인증 -->
          <IdCard v-if="kycMobileDefault" :resultName="'idCardResult'" @emitNext="next" />

          <!-- 주거래은행 계좌 1원인증 -->
          <WithdrawalAccount
            v-if="idCardResult"
            :resultName="'withdrawalAccountResult'"
            @emitNext="next"
          />

          <KycMobileWooriCrowd
            v-if="withdrawalAccountResult"
            :contractStatus="contractStatus"
            :resultName="'kycMobileWooriCrowdResult'"
            @emitNext="next"
          />

          <!-- 사업자등록증 -->
          <SignupDocuments
            v-if="kycMobileWooriCrowdResult"
            :resultName="isBuynowWooriCrowd ? 'bankCollectionsResult' : 'signupDocumentsResult'"
            @emitNext="next"
          />

          <!-- 집금용 계좌 등록 -->
          <BankCollections
            v-if="signupDocumentsResult"
            :resultName="'bankCollectionsResult'"
            @emitNext="next"
          />

          <!-- 소득금액 증명-->
          <CertifyIncome
            v-if="bankCollectionsResult"
            :resultName="isBuynowWooriCrowd ? 'completeLimitTransactionResult' : 'certifyIncomeResult'"
            @emitNext="next"
          />

          <!-- 계약서 작성 -->
          <CompleteLimitTransaction
            v-if="certifyIncomeResult"
            :resultName="'completeLimitTransactionResult'"
            @emitNext="next"
          />
          <!-- 계약서 작성 -->
          <!-- <CompleteLimitTransaction
            v-if="bankCollectionsResult"
            :resultName="'completeLimitTransactionResult'"
            @emitNext="next" -->
          />

          <ApplyBefore
            v-if="completeLimitTransactionResult"
            :resultName="'applyBeforeResult'"
            @emitNext="next"
          />
        </template>
        <template v-else-if="contractStatus === 'started' && !isBuynowWooriCrowd">
          <ContractLimitTransaction
            :resultName="'contractLimitTransactionResult'"
            @emitNext="next"
          />
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  components: {
    Me: () => import('./Me.vue'),
    // KycMobile: () => import('./kycMob/ile.vue'),
    SignupProblem: () => import('./SignupProblem.vue'),
    Store: () => import('./Store.vue'),
    SalesAccount: () => import('./SalesAccount.vue'),
    FactoringConfirm: () => import('./FactoringConfirm.vue'),
    IdCard: () => import('./IdCard'),
    SignupDocuments: () => import('./SignupDocuments.vue'),
    LoansOngoing: () => import('./LoansOngoing.vue'),
    Evaluation: () => import('./Evaluation.vue'),
    ContractCurrent: () => import('./ContractCurrent.vue'),
    LoadingSuccess: () => import('./LoadingSuccess.vue'),
    Agreement: () => import('./steps/pending/Agreement.vue'),
    // ContractDocuments: () => import('./steps/pending/ContractDocuments.vue'),
    // CollectionAccount: () => import('./steps/started/CollectionAccount.vue'),
    WithdrawalAccount: () => import('./steps/started/WithdrawalAccount.vue'),
    CertifyIncome: () => import('./steps/started/CertifyIncome.vue'),
    ContractLimitTransaction: () => import('./steps/completed/ContractLimitTransaction.vue'),
    CompleteLimitTransaction: () => import('./steps/completed/CompleteLimitTransaction.vue'),
    ApplyBefore: () => import('./steps/completed/ApplyBefore.vue'),
    // GuideReadyService: () => import('./steps/completed/GuideReadyService.vue'),
    FactoringSuccess: () => import('./FactoringSuccess.vue'),
    KycMobileWooriCrowd: () => import('./KycMobileWooriCrowd.vue'),
    KycMobileDefault: () => import('./KycMobileDefault.vue'),
    BankCollections: () => import('./BankCollections.vue'),
    // StatusLoading: () => import('./StatusLoading.vue'),
  },
  data() {
    return {
      agreementResult: false,
      contractCurrentResult: false,
      contractDocumentsResult: false,
      collectionAccountResult: false,
      withdrawalAccountResult: false,
      certifyIncomeResult: false,
      contractLimitTransactionResult: false,
      kycMobileResult: false,
      salesAccountResult: false,
      factoringConfirmResult: false,
      idCardResult: false,
      signupDocumentsResult: false,
      completeLimitTransactionResult: false,
      applyBeforeResult: false,
      guideReadyServiceResult: false,
      storeResult: false,
      factoringSuccessResult: false,
      statusLoadingResult: false,
      kycMobileWooriCrowdResult: false,
      kycMobileDefault: false,
      bankCollectionsResult: false,
      signupProblemResult: false,
    }
  },
  computed: {
    ...mapState('auth', ['info', 'me']),
    ...mapGetters('auth', ['referralCode', 'registerWooriCrowd']),
    ...mapState('contract', { contractCurrent: 'current' }),
    ...mapGetters('myfinbiz', ['platformCode']),

    isSignupManage() {
      return this.$cookies.get('signupManage') === 'manage'
    },
    isLoadingSuccess() {
      return this.info && this.me
    },
    contractStatus() {
      return this.contractCurrent?.status
    },
    isBuynowWooriCrowd() {
      console.log('PLATFORM CODE ', this.platformCode)
      return this.platformCode === 'buynow-woori-crowd'
    },
  },
  methods: {
    ...mapActions('auth', ['updateMe']),
    next({ name, result }) {
      this[name] = result

      console.log('NAME', name)
      console.log('RESULT', result)
    },
  },
}
</script>
